<!--
 - Author : wanghongling.
 - Date   : 2018/10/16.
 - File   : pie.饼图组件
 -->

<template>
  <div>
    <div :id="id" :style="{width: pieList.width||'360px', height: pieList.height, margin: pieList.margin}">
    </div>
  </div>
</template>

<script>
  export default {
    name: 'my-pie',
    data() {
      return {
        newLine: this.pieList.newLine || '',
        startAngle: this.pieList.startAngle || 90,
        finalPer: this.pieList.per ? '{per|{d}%}' : '',
        finalDw: this.pieList.dw ? this.pieList.dw : '',
        finalLabelShow: this.pieList.labelShow
      }
    },
    props: {
      id: {
        type: String,
        default: 'test'
      },
      pieList: {}
    },
    watch: {
      pieList: {
        handler() {
          this.$nextTick(() => {
            // window.removeEventListener('resize', this.resizeEvent)
            this.makePie()
          })
        },
        deep: true
      }
    },
    destroyed () {
      this.$echarts.dispose(this.myPie)
      // window.removeEventListener('resize', this.resizeEvent)
      this.myPie = null
    },
    mounted() {
      this.init()
    },
    methods: {
      /**
       * 初始化echart
       * @author: whl
       * @createDate: 2019/8/9
       * @return {Object}
       */
      init() {
        this.myPie = this.$echarts.init(document.getElementById(this.id))
        this.makePie()
      },
      /**
       * echart赋值
       * @author: whl
       * @createDate: 2019/8/9
       * @return {Object}
       */
      makePie() {
        let legend
        let legendType = this.pieList.legendType || ''
        let data = this.pieList.data
        let finalDw2 = this.finalDw
        switch (legendType) {
          case 0:
            legend = {
              show: false
            }
            break
          case 1:
            legend = {
              bottom: '5px',
              left: 'center',
              icon: 'roundRect',
              itemWidth: 19,
              itemHeight: 12,
              formatter: function(name) {
                for (let i = 0; i < data.length; i++) {
                  if (name === data[i].name) {
                    return '{name|' + name + '} {per|' + data[i].per + '}' + '\n' + '{num|' + data[i].value + '} {numDw|' + finalDw2 + '}'
                  }
                }
              },
              textStyle: {
                color: '#00c0ff',
                lineHeight: 20,
                rich: {
                  name: {
                    verticalAlign: 'top',
                    align: 'center',
                    padding: [0, 0, 15, 0],
                    fontSize: 14
                  },
                  per: {
                    verticalAlign: 'top',
                    align: 'center',
                    padding: [0, 0, 15, 0],
                    fontSize: 18
                  },
                  num: {
                    fontSize: 18,
                    padding: [0, 0, 25, 0],
                    color: '#fff'
                  },
                  numDw: {
                    fontSize: 15,
                    padding: [0, 0, 25, 0],
                    color: '#5f696f'
                  }
                }
              }
            }
            break
          case 2:
            legend = {
              orient: 'vertical',
              right: '10%',
              top: 'center',
              icon: 'roundRect',
              itemWidth: 19,
              itemHeight: 12,
              formatter: function(name) {
                for (let i = 0; i < data.length; i++) {
                  if (name === data[i].name) {
                    return '{per|' + data[i].per + '}' + '{perDw|%}' + '\n' + ' {name|' + name + '}'
                  }
                }
              },
              textStyle: {
                color: '#00a3ff',
                rich: {
                  per: {
                    verticalAlign: 'top',
                    fontSize: 25,
                    padding: [0, 0, 20, 0]
                  },
                  perDw: {
                    verticalAlign: 'top',
                    fontSize: 18,
                    padding: [0, 0, 20, 0]
                  },
                  name: {
                    fontSize: 14,
                    color: '#0aaade',
                    padding: [0, 0, 5, -30]
                  }
                }
              }
            }
            break
          case 3:
            legend = {
              bottom: '5px',
              left: 'center',
              icon: 'rect',
              itemWidth: 12,
              itemHeight: 12,
              formatter: function(name) {
                for (let i = 0; i < data.length; i++) {
                  if (name === data[i].name) {
                    return '{name|' + name + '} {per|' + data[i].per + '}' + '\n' + '{num|' + data[i].value + '} {numDw|' + finalDw2 + '}'
                  }
                }
              },
              textStyle: {
                color: '#00c0ff',
                lineHeight: 20,
                rich: {
                  name: {
                    verticalAlign: 'top',
                    align: 'center',
                    padding: [0, 0, 15, 0],
                    fontSize: 14
                  },
                  per: {
                    verticalAlign: 'top',
                    align: 'center',
                    color: '#b2c3c8',
                    padding: [0, 0, 15, 0],
                    fontSize: 14
                  },
                  num: {
                    fontSize: 16,
                    padding: [0, 0, 25, 0],
                    color: '#fff'
                  },
                  numDw: {
                    fontSize: 15,
                    padding: [0, 0, 25, 0],
                    color: '#5f696f'
                  }
                }
              }
            }
            break
          case 4:
            legend = {
              type: 'scroll',
              orient: 'vertical',
              right: 10,
              top: 40,
              bottom: 0,
              icon: 'circle',
              itemWidth: 12,
              itemHeight: 12,
              textStyle: {
                color: '#067aa0',
                fontSize: 12
              }
            }
            break
          default:
            legend = {
              show: this.pieList.legendShow,
              textStyle: {
                color: '#067aa0',
                fontSize: 12
              },
              bottom: -2,
              left: 'center',
              icon: 'circle',
              itemWidth: 12,
              itemHeight: 12
            }
            break
        }
        let option = {
          tooltip: {
            trigger: 'item',
            textStyle: {
              align: 'left'
            },
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
            borderColor: '#0ea1d6',
            borderWidth: 1,
            formatter: '{b} {d}%<br/>{c}' + this.finalDw
          },
          title: {
            text: this.pieList.title || '', // 中间显示的标题
            top: this.pieList.titleTop || 'center', // 中间显示的标题位置
            left: this.pieList.titleLeft || 'center', // 中间显示的标题位置
            textStyle: {
              color: '#fff',
              fontSize: 24,
              lineHeight: 10,
              fontWeight: 'normal'
            },
            subtextStyle: {//副标题文本样式{"color": "#aaa"}
              fontSize: 14,
              color: '#00c0ff',
              lineHeight: 10,
              fontWeight: 'normal'
            },
            subtext: this.pieList.subTitle || ''//副标题文本，'\n'指定换行
          },
          legend: legend,
          series: [
            {
              startAngle: this.startAngle,
              name: this.pieList.name,
              type: 'pie',
              center: this.pieList.piePos || ['50%', '50%'],
              radius: this.pieList.radius,
              color: this.pieList.color,
              roseType: this.pieList.roseType || '',
              label: {
                normal: {
                  show: this.finalLabelShow,
                  formatter: this.finalPer + '  {c|{c}}' + '{c|' + this.finalDw + '}' + this.newLine + '{b|{b}}',
                  borderWidth: 1,
                  borderRadius: 4,
                  lineHeight: 1,
                  rich: {
                    a: {
                      fontSize: 14,
                      color: '#999',
                      lineHeight: 22
                    },
                    b: {
                      fontSize: 14,
                      lineHeight: 20,
                      color: '#00c0ff'
                    },
                    per: {
                      fontSize: 14,
                      color: '#fff',
                      padding: [2, 4],
                      borderRadius: 2
                    },
                    c: {
                      fontSize: 16,
                      color: '#fff',
                      lineHeight: 10
                    }
                  }
                }
              },
              labelLine: {
                normal: {
                  length: 5
                }
              },
              data: this.pieList.data,
              animationDuration: 3000,
              animationDurationUpdate: 3000,
              animationDelay: function (idx) {
                return idx * 280 + 100
              }
            }
          ]
        }
        this.myPie.setOption(option)
        // window.addEventListener('resize', this.resizeEvent)
      },
      /**
       * echart图表适应
       * @author: whl
       * @createDate: 2019/8/9
       * @return {Object}
       */
      resizeEvent() {
        this.myPie.resize() // 使图表适应
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/echarts/pie.vue